
import { Options, Vue } from 'vue-class-component'

import api from '@/api'
import { toDate } from '../utils/common'
import store from '../store'

@Options({
  components: {}
})
export default class black extends Vue {
  toDate = toDate;
  table:any = []
  loading = false

  created () {
    this.loading = true
    api.queryEnterpriseBlacklists(store.getters['company/get']).then((data:any) => {
      this.table = [data]
    }).finally(() => {
      this.loading = false
    })
  }
}
